import {FACET_NAMES} from './googleAdConstants';

const getCategory = (appliedFacets = [], mainCategoryId) => {
  let categoryValue = [];
  categoryValue.push(`${mainCategoryId}`)
  const categoryAppliedFacet = appliedFacets?.filter(appliedFacet => appliedFacet?.name === FACET_NAMES.CATEGORY);
  categoryAppliedFacet?.map((facet) => {
    facet?.selectedValues?.map((selectedValue) => {
      categoryValue.push(selectedValue.value)
    })
  })

  //todo change parameter names
  let unique = categoryValue.filter((v, i, a) => a.indexOf(v) === i);
  return unique?.join();
};

const getBrand = (appliedFacets = []) => {
  const brandAppliedFacet = appliedFacets?.filter(appliedFacet => appliedFacet.name === FACET_NAMES.BRAND)
  return brandAppliedFacet?.[0]?.selectedValues?.map(values => values.displayName)?.join();
};

const getBrandByUtagData = () => {
  if(window){
    const brandFilters = window?.utagData?.applied_brand_filters || [];
    return brandFilters?.map(brand => brand?.title)?.join(',');
  }
  return '';
}

const getCategoryByUtagData = () => {
  if(window){
    const categoryFilters = window?.utagData?.category_hierarchy || [];
    return categoryFilters?.reverse().map(category => category?.id)?.
      join(',');
  }
  return '';
}

const getFilters = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const filterParamsPath = urlParams.get(FACET_NAMES.FILTERS);
  const ratingParamsValue = urlParams.get(FACET_NAMES.RATING);
  const queryParamsValue = urlParams.get('q');

  const filterParams = filterParamsPath?.split(';');
  const ratingParam = ratingParamsValue ? {[FACET_NAMES.RATING]: ratingParamsValue} : {};
  const queryParam = queryParamsValue ? {keyword: queryParamsValue} : {};

  const params = filterParams?.reduce((obj, item) => {
    const [key, value] = item?.split(';');
    return {
      ...obj,
      [key]: value
    };
  }, {});

  return {...params, ...ratingParam, ...queryParam};
};

export {
  getCategory,
  getFilters,
  getBrand,
  getCategoryByUtagData,
  getBrandByUtagData,
}
